import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core';
import { AdvancedRateDimensionsGroup } from '~/modules/rateCard/advancedRateCard/components/AdvancedRateDimensionsGroup';
import { CostOverridesTable } from './CostOverridesTable';
import { NoCostRatesMessage } from './NoCostRatesMessage';

const useStyles = makeStyles(theme => ({
  stickyDimensions: {
    position: 'sticky',
    top: 0,
    minHeight: theme.spacing(6),
    display: 'flex',
    alignItems: 'center',
    backgroundColor: theme.palette.background.paper,
    borderBottom: `1px solid ${theme.palette.divider}`,
    zIndex: theme.zIndex.appBar
  }
}));

export const ProjectCostOverridesDialogContent = ({
  projectSlug,
  projectCurrency,
  editor,
  availableDimensions,
  errors,
  hasMore = false,
  loadingMore = false,
  loadMore,
  openDeleteDialog,
  readOnly = false
}) => {
  const classes = useStyles();
  const {
    selectedDimensions,
    projectRates,
    addNewEntry,
    setAddNewEntry,
    formOnChange
  } = editor;

  return (
    <div>
      {readOnly ? null : (
        <div className={classes.stickyDimensions}>
          <AdvancedRateDimensionsGroup
            projectDimensions={selectedDimensions}
            availableRateTableDimensions={availableDimensions}
            formOnChange={formOnChange}
            projectRates={projectRates}
            loadingMore={loadingMore || hasMore}
            labelMessageId="projectCostOverrides.dialog.defineCostOverridesBy"
          />
        </div>
      )}
      {selectedDimensions.length > 0 ? (
        <CostOverridesTable
          selectedDimensions={selectedDimensions}
          projectRates={projectRates}
          formOnChange={formOnChange}
          projectSlug={projectSlug}
          projectCurrency={projectCurrency}
          addNewEntry={addNewEntry}
          setAddNewEntry={setAddNewEntry}
          errors={errors}
          hasMore={hasMore}
          loadingMore={loadingMore}
          loadMore={loadMore}
          openDeleteDialog={openDeleteDialog}
          readOnly={readOnly}
        />
      ) : (
        <NoCostRatesMessage />
      )}
    </div>
  );
};

ProjectCostOverridesDialogContent.propTypes = {
  projectSlug: PropTypes.string,
  projectCurrency: PropTypes.object,
  editor: PropTypes.object.isRequired,
  availableDimensions: PropTypes.array.isRequired,
  errors: PropTypes.object,
  hasMore: PropTypes.bool,
  loadingMore: PropTypes.bool,
  loadMore: PropTypes.func,
  openDeleteDialog: PropTypes.func,
  readOnly: PropTypes.bool
};

export default ProjectCostOverridesDialogContent;
